import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Spin } from "antd";
import { useAuth } from "app/contexts/AuthContext";

/**
 * PrivateRoute - Bảo vệ các route yêu cầu đăng nhập.
 *
 * Luồng xử lý:
 *  - isLoading = true  → Đang kiểm tra session (F5) → Hiển thị màn hình loading
 *  - user = null       → Chưa đăng nhập → Redirect về /signin
 *  - user có giá trị  → Đã đăng nhập → Render layout/page bình thường
 */
const PrivateRoute = () => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "#f0f2f5",
        }}
      >
        <Spin size="large" tip="Đang xác thực..." />
      </div>
    );
  }

  if (!user) {
    // Không có user → chưa đăng nhập → về trang signin
    return <Navigate to="/signin" state={{ from: location.pathname + location.search }} replace />;
  }

  // Đã đăng nhập → render nội dung bên trong (AdminLayout + pages)
  return <Outlet />;
};

export default PrivateRoute;
